import React, { useState } from 'react'
import CustomSpinner from '../../../components/CustomSpinner';
import SettingsTabs from './SettingsTabs';

const Settings = () => {
    const [tabValue, setTabValue] = useState(0)
    const [loading, setLoading] = useState(false);

    return (
        <div className='settings'>
            <div className='grid grid-cols-12 gap-x-5 gap-y-5'>
                <div className='col-span-12'>
                    <div className='card'>
                        <SettingsTabs
                            tabValue={tabValue}
                            setTabValue={setTabValue}
                            setLoading={setLoading}
                        />
                    </div>
                </div>
            </div>
            {
                loading && <CustomSpinner loading={loading} />
            }
        </div>
    )
}

export default Settings